module.exports = require("./zh-Hant-HK.d.ts");